import { createFileRoute } from '@tanstack/react-router';
import SSOLoginHandler from '../Containers/SSOLoginHandler';

export const Route = createFileRoute('/login_/sso-login')({
  component: SSOLoginHandler,
});
